export const returnInwardFormData = () => ({
  inputData: {
    warehouse_id: null,
    project_id: null,
    user_id: null,
    return_when: "xyz",
    type: "Return Inward",
    remark: "",
    date: "",
    created_by: 1,
    is_active: true,
    return_inward_items: [],
  },
});

export const createPageData = () => {
  const payload = {
    modelName: "return_inwards",

    relation: [
      {
        modelName: "return_inward_items",
        moduleAs: "return_inward_items",
        foreignKey: "return_inward_id",
      },
    ],
  };

  const navigatePage = { back: "/return-inward-list" };

  const headerName = "Return Inward";

  const validationType = "ReturnInwardCreate";
  const createEndpoint = "/createReturnInward";
  const getEndpoint = "/listReturnInward";

  const itemTypeOptions = [
    { label: "Main", value: 1 },
    { label: "Faulty", value: 2 },
  ];
  const inwardTypeOptions = [
    { label: "Return Inward", value: "Return Inward" },
    { label: "MRB", value: "MRB" },
    { label: "Provision", value: "Provision"},
  ];

  return {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    getEndpoint,
    itemTypeOptions,
    inwardTypeOptions,
  };
};
